<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav" />
    <div class="record-detail">
      <div class="bg-img">
        <img :src="songAvatar" alt="" />
        <div class="bg"></div>
      </div>
      <div class="main-box">
        <div class="record-info">
          <div class="song-ava" >
            <i></i>
            <span v-if="audioDetail.extent" >{{ audioDetail.extent }}</span>
          </div>
          <div class="info">
            <div
              class="name"
              v-if="audioDetail.dctitle && audioDetail.dctitle['@value']"
            >
              {{ audioDetail.dctitle["@value"] }}
            </div>
            <div class="des" v-if="audioDetail.contribution">
             
                    <SingerTemplate :recordInfo="audioDetail"></SingerTemplate>
            </div>
            <div :class="showMore ? 'des-box cur' : 'des-box'">
              <div class="des" v-if="audioDetail.description">
                {{ audioDetail.description }}
              </div>
            </div>
            <div class="des-box">
             <div class="a-lk" v-if="audioDetail.topic">
              <a
                href="javascript:;"
                v-for="(item, index) in audioDetail.topicYear"
                :key="'year' + index"
              >
                <i :class="type[item.type]"></i>{{ item.label }}
              </a>
                <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicPerson"
                  :key="'person' + index"
                >
                  <i class="ra" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicPerson.length - 1">、</b>
                </b>
              </a>
              <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicPlace"
                  :key="'place' + index"
                >
                  <i class="sf" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicPlace.length - 1">、</b>
                </b>
              </a>
               <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicOrg"
                  :key="'org' + index"
                >
                  <i class="org" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicOrg.length - 1">、</b>
                </b>
              </a>
            </div>
            </div>

            <a
              href="javascript:"
              :class="showMore ? 'more cur' : 'more'"
              @click="showMore = !showMore"
              v-if="audioDetail.description"
            >
              {{ showMore ? "收起" : "展开" }}<i></i>
            </a>
            <div class="btns-d">
              <a href="javascript:" class="play" @click="playSong(audioDetail)"
                ><i></i>播放</a
              >
              <ShareDialog ref="share"
                ><a href="javascript:" class="share" @click="handleShare"
                  ><i></i>分享</a
                ></ShareDialog
              >
              <a
                href="javascript:"
                :class="audioDetail.isFavorite ? 'fav cur' : 'fav'"
                @click="handleSingleFav"
                ><i></i>{{ audioDetail.isFavorite ? "已" : "" }}收藏</a
              >
            </div>
          </div>
        </div>
        <div class="mb-detail-info">
          
           <div class="des" v-if="audioDetail.contribution">
                   <SingerTemplate :recordInfo="audioDetail"></SingerTemplate>
          </div>
          <div :class="showMore ? 'des-box cur' : 'des-box'">
            <div class="des" v-if="audioDetail.description">
              {{ audioDetail.description }}
            </div>
          </div>
          <div class="des-box">
            <div class="a-lk" v-if="audioDetail.topic">
              <a
                href="javascript:;"
                v-for="(item, index) in audioDetail.topicYear"
                :key="'year' + index"
              >
                <i :class="type[item.type]"></i>{{ item.label }}
              </a>
                <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicPerson"
                  :key="'person' + index"
                >
                  <i class="ra" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicPerson.length - 1">、</b>
                </b>
              </a>
              <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicPlace"
                  :key="'place' + index"
                >
                  <i class="sf" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicPlace.length - 1">、</b>
                </b>
              </a>
               <a href="javascript:;">
                <b
                  v-for="(item, index) in audioDetail.topicOrg"
                  :key="'org' + index"
                >
                  <i class="org" v-if="index == 0"></i>
                  {{ item.label }}
                  <b v-if="index != audioDetail.topicOrg.length - 1">、</b>
                </b>
              </a>
            </div>
          </div>
          <a
            href="javascript:"
            :class="showMore ? 'more cur' : 'more'"
            @click="showMore = !showMore"
            v-if="audioDetail.description"
          >
            {{ showMore ? "收起" : "展开" }}<i></i>
          </a>
        </div>
        <div class="record-info-detail">
          <div class="des-info">
            <div class="left-des">
              <div
                class="bs-info"
                v-if="audioDetail.dctitle && audioDetail.dctitle['@value']"
              >
                <span class="lb">歌曲名称</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.dctitle["@value"]
                  }}<span v-if="audioDetail.alternative"
                    >，又名{{ audioDetail.alternative }}</span
                  ></span
                >
                <!-- <span class="vl">金额慕名，又名 XXXXXX、XXXXXX</span> -->
              </div>
              <div class="bs-info" v-if="audioDetail.artStyle">
                <span class="lb">风格流派</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.artStyle }}</span>
              </div>

              <div class="bs-info" v-if="audioDetail.extent">
                <span class="lb">时长</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.extent }}</span>
              </div>
              <div
                class="bs-info"
                v-if="audioDetail.place && Array.isArray(audioDetail.place)"
              >
                <span class="lb">地域特色</span>
                <div class="mh">:</div>
                <span class="vl">
                  <span
                    v-for="(p, pIndex) in audioDetail.place"
                    :key="'place' + pIndex"
                  >
                    {{ p.label ? p.chsPlc + "&nbsp;&nbsp;" : "" }}
                  </span>
                </span>
              </div>
              <div class="bs-info" v-else-if="audioDetail.place">
                <span class="lb">地域特色</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.place.chsPlc }}</span>
              </div>
            <div class="bs-info" v-if="audioDetail.contribution">
                <span class="lb">乐人</span>
                <div class="mh">:</div>
                <span class="vl" >
                  <SingerTemplate :recordInfo="audioDetail"></SingerTemplate>
               </span>
              </div>
               
              <div class="bs-info" v-if="audioDetail.band">
                <span class="lb">乐队</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.band }}</span
                >
              </div>
              <div class="bs-info" v-if="audioDetail.instrument">
                <span class="lb">乐器</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.instrument }}</span
                >
              </div>
              <div class="bs-info" v-if="audioDetail.singingForm">
                <span class="lb">演唱形式</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.singingForm }}</span
                >
              </div>
            <!-- </div> -->
            <!-- <div class="left-des"> -->
              
              <div class="bs-info" v-if="audioDetail.subject">
                <span class="lb">题材</span>
                <div class="mh">:</div>
                <span class="vl">
                  {{ audioDetail.subject }}
                </span>
              </div>
              <div class="bs-info" v-if="audioDetail.genre">
                <span class="lb">体裁</span>
                <div class="mh">:</div>
                <span class="vl">
                  {{ audioDetail.genre }}
                </span>
              </div>
              <div class="bs-info" v-if="audioDetail.section">
                <span class="lb">篇幅</span>
                <div class="mh">:</div>
                <span class="vl">
                  {{ audioDetail.section }}
                </span>
              </div>
              <div class="bs-info" v-if="audioDetail.dramaType">
                <span class="lb">曲种</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.dramaType }}</span>
              </div>
              <div class="bs-info" v-if="audioDetail.language">
                <span class="lb">语种</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.language }}</span
                >
              </div>
              <!-- <div class="bs-info" v-if="audioDetail.identifier">
                <span class="lb">标识</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.identifier }}</span>
              </div> -->
              <!-- <div class="bs-info" v-if="audioDetail.serialNo">
                <span class="lb">顺序号</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.serialNo }}</span>
              </div> -->
              <div class="bs-info" v-if="audioDetail.alternative">
                <span class="lb">并列题名</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.alternative }}</span>
              </div>
              
              <div class="bs-info" v-if="audioDetail.artStyle">
                <span class="lb">风格流派</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.artStyle }}</span>
              </div>
              <div class="bs-info" v-if="audioDetail.aria">
                <span class="lb">唱法唱腔</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.aria }}</span>
              </div>
              
               <div class="bs-info" v-if="audioDetail.profession">
                <span class="lb">行当</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.profession }}</span>
              </div>
               <div class="bs-info" v-if="audioDetail.lyric">
                <span class="lb">歌词</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ audioDetail.lyric }}</span
                >
              </div>
              <div class="bs-info" v-if="audioDetail.note">
                <span class="lb">说明</span>
                <div class="mh">:</div>
                <span class="vl">{{ audioDetail.note }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="collection-info" v-if="audioDetail.phonorecord">
          <router-link
            :to="
              '/rec-info/' +
              encodeURIComponent(audioDetail.phonorecord['@id'])
            "
            class="check-detail"
            >查看详情<i></i></router-link>
          <div class="from-info">
            <!-- <img :src="songAvatar" alt="" /> -->
            <div class="pic">
              <router-link
                :to="
                  '/rec-info/' +
                  encodeURIComponent(audioDetail.phonorecord['@id'])
                "
              >
                <img
                  v-if="audioDetail.phonorecord['cover'][0]"
                  :src="
                    'https://img.library.sh.cn/hisdata/cp/img/' +
                    audioDetail.phonorecord['cover'][0]
                  "
                  alt=""
                />
                <img v-else :src="baseRecordPic" alt="" />
              </router-link>
            </div>

            <div class="info">
              <div class="f">
                来自唱片：
                <router-link
                  v-if="audioDetail.phonorecord['@id']"
                  :to="
                    '/rec-info/' +
                    encodeURIComponent(audioDetail.phonorecord['@id'])
                  "
                  >
                   {{audioDetail.phonorecord["dcTitle"]["@value"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') }}
                  
                  </router-link
                >
              </div>
              <div class="if" v-if="audioDetail.phonorecord['provisionActivity'] && audioDetail.phonorecord['provisionActivity']['date']">出版时间：<span>{{audioDetail.phonorecord['provisionActivity']['date']}}</span></div>
              <div class="if" v-if="audioDetail.phonorecord['provisionActivity'] && audioDetail.phonorecord['provisionActivity']['agentLabel']">
                出版者： <router-link
                v-if="audioDetail.phonorecord['provisionActivity'] && audioDetail.phonorecord['provisionActivity']['agent'] && audioDetail.phonorecord['provisionActivity']['agent']['@id'].indexOf('http://data.library.sh.cn/entity/organization')>=0"
            :to="
              '/company-detail/' +
              encodeURIComponent(audioDetail.phonorecord['provisionActivity']['agent']['@id'])
            ">{{audioDetail.phonorecord['provisionActivity']['agentLabel']}}</router-link>
            <span v-else>{{audioDetail.phonorecord['provisionActivity']['agentLabel']}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="space-footer"></div>
    <Player ref="player" @saveFav="saveFav" />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import ShareDialog from "@/components/shareDialog";
import Player from "@/components/player";
import SingerTemplate from "@/components/singer";
import { musicInfo } from "@/api";
import { createFavorite, collFav, ncollFav } from "@/api";
export default {
  components: {
    Nav,
    ShareDialog,
    Player,
    SingerTemplate
  },
  data() {
    return {
      loginHref: null,
      isLogin: false,
      sc: false,
      noplay: false,
      player: [],
      queryUri: decodeURIComponent(this.$route.params.id),
      songAvatar: require("./../../../public/img/demo/image3.png"),
      showMore: false,
      isFav: false,
      audioDetail: {},
      song: [],
      type: {
        时代: "cd",
        人物: "ra",
        地点: "sf",
        组织: "org",
      },
    };
  },
  watch: {
    $route(to, from) {
      var id = this.$route.params.id;
      //console.log("route change", id);

      this.queryUri = decodeURIComponent(this.$route.params.id);
      this.query();
    },
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    this.$nextTick(() => {
      //console.log(this.queryUri);
      this.query();
    });
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer();
    next();
  },
  methods: {
    async query(flag = true) {
      const res = await musicInfo({ uri: this.queryUri });
      //console.log(res);
      this.audioDetail = res.data && res.data.datas ? res.data.datas : {};
      //时代
      let arr = [];
      if ( this.audioDetail.topic && !Array.isArray(this.audioDetail.topic))
      {
        arr.push(this.audioDetail.topic);
        if (this.audioDetail.topic.type == "时代"){
          this.audioDetail["topicYear"] = arr;
        }
        if (this.audioDetail.topic.type == "人物"){
          this.audioDetail["topicPerson"] = arr;
        }
        if (this.audioDetail.topic.type == "地点"){
          this.audioDetail["topicPlace"] = arr;
        }
        if (this.audioDetail.topic.type == "机构"){
          this.audioDetail["topicOrg"] = arr;
        }
      }
      else  if (this.audioDetail.topic && Array.isArray(this.audioDetail.topic)) {
       let year = [];let person = [];let place = []; let org = [];
        for (let i = 0; i < this.audioDetail.topic.length; i++) {
          if (this.audioDetail.topic[i].type == "时代") {
              year = year.concat(this.audioDetail.topic[i]);
          } else  if (this.audioDetail.topic[i].type == "人物") {
             person = person.concat(this.audioDetail.topic[i]);
          }
          else if (this.audioDetail.topic[i].type == "地点") {
             place = place.concat(this.audioDetail.topic[i]);

          }
           else if (this.audioDetail.topic[i].type == "机构") {
             org = org.concat(this.audioDetail.topic[i]);
          }
        }
        this.audioDetail["topicYear"] = year;
        this.audioDetail["topicPerson"] = person;
        this.audioDetail["topicPlace"] = place;
        this.audioDetail["topicOrg"] = org;
      
      }
    },
    async playSong(item) {
      this.$refs.player.playSingleSong(this.$refs.Nav, item);
    },
    async handleSingleFav() {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.audioDetail.isFavorite
        ? await ncollFav({ uri: this.audioDetail["@id"] })
        : await collFav({ uri: this.audioDetail["@id"] });
      this.audioDetail.isFavorite = !this.audioDetail.isFavorite;
      this.$refs.player.saveFav(this.audioDetail);
      this.$refs.Nav.cpnclick(this.audioDetail.isFavorite);
    },
    saveFav(data) {
      if (this.audioDetail["@id"] == data["singer"]) {
        this.audioDetail["isFavorite"] = !this.audioDetail["isFavorite"];
      }
    },
    handleShare() {
      // this.$refs.share.visible=!this.$refs.share.visible
      this.$refs.share.show();
    },
    typeHandle(key) {
      return this.type[key];
    },
  },
};
</script>
